// src/lib/practicePreferencesApi.js
//
// Domain API for practice-level wizard preferences. Pure data access - no
// React. See hooks/usePracticePreferences.js for the React shape.

import { supabase } from "./supabaseClient";

// Returns the `preferences` JSONB for a practice, or {} when the practice has
// no row yet (maybeSingle -> null).
//
// Load failure resolves to {} rather than throwing. This is deliberate and
// matches the hook it replaced: preferences power PERMISSIVE UI gates, and a
// transient read failure must degrade to "show the default UI", not to a
// blank screen or a locked-out user. The failure is still surfaced on the
// console so it is not silent.
export async function fetchPracticePreferences(practiceId) {
  if (!practiceId) return {};
  const { data, error } = await supabase
    .from("practice_preferences")
    .select("preferences")
    .eq("practice_id", practiceId)
    .maybeSingle();
  if (error) {
    console.warn("[usePracticePreferences] load failed:", error.message);
    return {};
  }
  return (data && data.preferences) || {};
}
